<template>
    <b-form class="create-user-form" @submit.stop.prevent="onSubmit">
        <div id="first-name" class="group-wrapper">
            <label>First Name</label>
            <b-form-input id="first-name" v-model="form.firstName" required></b-form-input>
        </div>

        <div id="last-name" class="group-wrapper">
            <label>Last Name</label>
            <b-form-input id="last-name" v-model="form.lastName" required></b-form-input>
        </div>

        <div id="user-name" class="group-wrapper">
            <label>User Name</label>
            <div class="user-name-input-wrapper">
                <b-form-input
                    id="userName"
                    v-model="form.userName"
                    required
                    @focus="shouldHideError('userName')"
                ></b-form-input>
                <p>{{ validationErrors.userName }}</p>
            </div>
        </div>

        <div id="email" class="group-wrapper">
            <label>Email</label>
            <div class="email-input-wrapper">
                <b-form-input
                    id="email"
                    v-model="form.email"
                    required
                    type="email"
                    @focus="shouldHideError('email')"
                ></b-form-input>
                <p>{{ validationErrors.email }}</p>
            </div>
        </div>

        <div id="tenants" class="group-wrapper">
            <label>Tenants</label>
            <div class="tenant-select-wrapper">
                <multiselect
                    v-model="form.tenants"
                    :options="tenants"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder=""
                    :preselect-first="true"
                    label="name"
                    track-by="_id"
                    :show-labels="false"
                    @open="shouldHideError('tenants')"
                >
                </multiselect>
                <p>{{ validationErrors.tenants }}</p>
            </div>
        </div>

        <div id="image-url" class="group-wrapper">
            <label>Image URL</label>
            <b-form-input
                id="image-url"
                v-model="form.imageUrl"
                placeholder="Optional"
            ></b-form-input>
        </div>

        <div id="role" class="group-wrapper">
            <label>Role</label>
            <div class="buttons-wrapper">
                <b-form-radio v-model="form.role" value="agent">Agent</b-form-radio>
                <b-form-radio v-model="form.role" value="employee">Employee</b-form-radio>
            </div>
        </div>

        <div class="group-wrapper">
            <label>Temporary Password</label>
            <b-form-checkbox v-model="form.isPasswordTemp" :value="true" :unchecked-value="false" />
        </div>

        <div id="submit" class="group-wrapper">
            <b-button type="submit" variant="primary">Submit</b-button>
        </div>
    </b-form>
</template>

<script>
import BackendProvider from '../../../../business/services/BackendProvider'
import UIUtils from '../../../../business/utils/UIUtils'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
    name: 'CreateUserForm',
    components: { Multiselect },
    data() {
        return {
            form: {
                userName: '',
                firstName: '',
                lastName: '',
                imageUrl: '',
                email: '',
                role: '',
                tenants: [],
                isPasswordTemp: false
            },
            tenants: [],
            validationErrors: {
                userName: '',
                email: '',
                tenants: ''
            },
            validationMessages: {
                DUPLICATE_USER: 'User exists with same username',
                DUPLICATE_EMAIL: 'User exists with same email',
                INVALID_EMAIL: 'Email must be in valid email format',
                MUST_SELECT: 'Please select a value'
            }
        }
    },
    computed: {
        tenantIdObjectsArray() {
            return this.form.tenants.map(t => {
                return {
                    _id: t._id
                }
            })
        }
    },
    mounted() {
        this.loadTenants()
    },
    methods: {
        async onSubmit() {
            UIUtils.showLoadingMask()
            this.validateInputFields()
            if (this.isInputValid())
                try {
                    if (!this.form.imageUrl) this.form.imageUrl = 'empty'
                    const createdUser = await this.createUser()
                    UIUtils.toast(
                        `user name: ${this.form.userName} password: ${createdUser.password}`,
                        'message',
                        30 * 1000
                    )
                    this.$bvModal.hide('create_user')
                } catch (e) {
                    this.handleValidationError(e.message)
                }
            UIUtils.hideLoadingMask()
        },
        async createUser() {
            const { userName, firstName, lastName, email, imageUrl, role, isPasswordTemp } =
                this.form

            return await BackendProvider.createUser({
                userName,
                firstName,
                lastName,
                email,
                tenants: this.tenantIdObjectsArray,
                imageUrl,
                role: role || null,
                isPasswordTemp
            })
        },
        validateInputFields() {
            if (this.form.tenants.length === 0)
                this.validationErrors.tenants = this.validationMessages.MUST_SELECT
        },
        isInputValid() {
            return Object.values(this.validationErrors).every(value => value === '')
        },
        handleValidationError(message) {
            switch (true) {
                case message === this.validationMessages.DUPLICATE_USER:
                    this.validationErrors.userName = message
                    break
                case message === this.validationMessages.DUPLICATE_EMAIL ||
                    message === this.validationMessages.INVALID_EMAIL:
                    this.validationErrors.email = message
                    break
                default:
                    UIUtils.toast(message, 'danger', 10 * 1000)
            }
        },
        shouldHideError(id) {
            if (this.validationErrors[id]) this.validationErrors[id] = ''
        },
        async loadTenants() {
            this.tenants = await BackendProvider.getAllTenants()
        }
    }
}
</script>

<style lang="scss" scoped>
.create-user-form {
    position: relative;
    width: 30rem;

    .group-wrapper {
        position: relative;
        display: grid;
        grid-template-columns: 40% 60%;
        align-items: center;
        padding: 0.5rem;
        min-height: 4.5rem;

        label {
            padding-top: 3%;
        }

        p {
            color: $red;
            font-size: 0.9rem;
            margin: 0;
            padding-top: 0.1rem;
        }

        .user-name-input-wrapper,
        .email-input-wrapper {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            padding-top: 0.5rem;
        }

        .buttons-wrapper {
            display: flex;
            justify-content: space-around;
        }
    }

    #submit.group-wrapper {
        display: flex;
        justify-content: center;
    }
}
</style>

<!--override vue multiselect component styles-->
<style lang="scss">
#tenants.group-wrapper {
    .multiselect {
        z-index: 2;
        font-size: 0.9rem;
        position: relative;

        .multiselect__tags {
            background-color: $dark-2;
            border-radius: 0.3rem;
            border-color: $light;

            .multiselect__tags-wrap {
                .multiselect__tag {
                    background-color: $blue;
                    .multiselect__tag-icon {
                        background-color: transparent;
                    }
                }
            }
            .multiselect__placeholder {
                font-size: 0.9rem;
            }
            .multiselect__input {
                background-color: $dark-2;
                color: $light;
                font-size: 0.9rem;
            }
        }

        .multiselect__content-wrapper {
            position: absolute;
            max-height: 10rem;
            background-color: $dark-2;
            border-color: $light;
            border-radius: 0.3rem;

            .multiselect__content {
                background-color: $dark-2;
                color: $light-2;
                max-height: 10rem;

                .multiselect__element {
                    .multiselect__option--highlight {
                        background-color: $blue;
                    }
                    .multiselect__option--selected {
                        background-color: $blue;
                    }
                }
            }
        }
    }

    .multiselect--active {
        position: absolute;
        top: 0.8rem;
        left: 12.1rem;
        width: 17.43rem;
        height: 100%;
    }
}
</style>
